module.exports = __webpack_public_path__ + "static/dolgrim-4742d6b7b7ee3a347225ffcfcfcd8456.png";